import { useEffect, useState } from "react";

import "./styles.css"
const Trackbar = ({ currentTime, totalTime, onTimeUpdate }) =>
{

  const [currentPercentProgress, setCurrentPercentProgress] = useState(0);

  useEffect(() =>
  {
    setCurrentPercentProgress((currentTime / totalTime) * 100)
  }, [currentTime, totalTime])

  const calculate_clicked_time = (evt) =>
  {
    const scuffalicious = document.querySelector(".bar");
    const clickPos = evt.pageX;
    const barStart = scuffalicious.getBoundingClientRect().left + window.scrollX;
    const barWidth = scuffalicious.offsetWidth;
    const clickPosInBar = clickPos - barStart;
    const timePerPixel = totalTime / barWidth;
    return (timePerPixel * clickPosInBar);
  }

  const handleTimeDrag = (evt) =>
  {
    onTimeUpdate(calculate_clicked_time(evt));

    const updateTimeOnMove = (move_evt) =>
    {
      onTimeUpdate(calculate_clicked_time(move_evt));
    }

    document.addEventListener("mousemove", updateTimeOnMove);

    document.addEventListener("mouseup", () =>
    {
      document.removeEventListener("mousemove", updateTimeOnMove);
    })
  }

  return (
    <div>
      <div className="bar">
        <div className="bar_progress" style={{
          background: `linear-gradient(to right, #000 ${currentPercentProgress}%, white)`
        }} onMouseDown={(evt) => handleTimeDrag(evt)}>
          <span className="knob" style={{ left: `${currentPercentProgress}%` }} />
        </div>
      </div>
    </div>
  );
}

export default Trackbar;
